// Spanish translations
export default {
  common: {
    loading: 'Cargando...',
    error: 'Ha ocurrido un error',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    view: 'Ver',
    search: 'Buscar',
    filter: 'Filtrar',
    noResults: 'No se encontraron resultados',
    back: 'Atrás',
    next: 'Siguiente',
    previous: 'Anterior',
    submit: 'Enviar',
    reset: 'Restablecer',
    required: 'Obligatorio',
    optional: 'Opcional',
    yes: 'Sí',
    no: 'No',
    success: 'Éxito',
    confirm: 'Confirmar',
    type: 'Escriba',
    actions: 'Acciones',
    notifications: 'Notificaciones',
    menu: 'Menú',
    noNotifications: 'No hay notificaciones nuevas',
    markAllAsRead: 'Marcar todas como leídas',
    dismiss: 'Descartar',
    viewAll: 'Ver todas',
    serverNotResponding: 'El servidor no responde. Por favor, compruebe su conexión.',
    unexpectedError: 'Ha ocurrido un error inesperado',
    tryAgain: 'Por favor, inténtelo de nuevo',

    // Additional evaluation-related common terms
    performance: 'Rendimiento',
    feedback: 'Retroalimentación',
    development: 'Desarrollo',
    goals: 'Objetivos',
    skills: 'Habilidades',
    competencies: 'Competencias',
    strengths: 'Fortalezas',
    areasForImprovement: 'Áreas de Mejora',
    leadership: 'Liderazgo',
    teamwork: 'Trabajo en Equipo',
    communication: 'Comunicación',
    customerService: 'Servicio al Cliente',
    quality: 'Calidad',
    efficiency: 'Eficiencia',
    reliability: 'Confiabilidad',
    initiative: 'Iniciativa',
    problemSolving: 'Resolución de Problemas',
    adaptability: 'Adaptabilidad',
    accountability: 'Responsabilidad',
    team: 'Equipo',
    temp: 'Plant',
    new: 'Nuevo',
    contactSupport: 'Si el problema persiste, póngase en contacto con soporte',
    store: 'Tienda',
    goodMorning: 'Buenos Días',
    goodAfternoon: 'Buenas Tardes',
    goodEvening: 'Buenas Noches',
    user: 'Usuario'
  },
  auth: {
    login: 'Iniciar Sesión',
    logout: 'Cerrar Sesión',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    forgotPassword: '¿Olvidó su Contraseña?',
    resetPassword: 'Restablecer Contraseña',
    newPassword: 'Nueva Contraseña',
    confirmPassword: 'Confirmar Contraseña',
    signIn: 'Iniciar sesión en su cuenta',
    signingIn: 'Iniciando sesión...',
    rememberMe: 'Recordarme',
    loginError: 'Error al iniciar sesión',
    passwordResetSent: 'Si existe una cuenta con este correo electrónico, recibirá instrucciones para restablecer su contraseña',
    passwordResetSuccess: 'Su contraseña ha sido restablecida con éxito',
    emailRequired: 'El correo electrónico es obligatorio',
    invalidEmail: 'Por favor, introduzca una dirección de correo electrónico válida',
    passwordRequired: 'La contraseña es obligatoria',
    passwordLength: 'La contraseña debe tener al menos 6 caracteres',
    noAccount: '¿No tiene una cuenta?',
    registerCta: 'Regístrese',
    passwordResetInstructions: 'Ingrese su dirección de correo electrónico y le enviaremos instrucciones para restablecer su contraseña',
    sending: 'Enviando...',
    sendResetInstructions: 'Enviar instrucciones de restablecimiento',
    checkEmailForReset: 'Revise su correo electrónico para obtener instrucciones de restablecimiento de contraseña. El enlace caducará en 1 hora',
    didntReceiveEmail: '¿No recibió el correo electrónico? Revise su carpeta de spam o inténtelo de nuevo',
    backToLogin: 'Volver a iniciar sesión',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
    passwordResetSuccessTitle: 'Restablecimiento de Contraseña Exitoso',
    passwordResetSuccessMessage: 'Su contraseña ha sido restablecida. Será redirigido al inicio de sesión.',
    resetPasswordError: 'Error al restablecer la contraseña',
    invalidResetLink: 'Enlace de restablecimiento no válido. Por favor, solicite un nuevo restablecimiento de contraseña.',
    goToForgotPassword: 'Ir a olvidé mi contraseña',
    resetting: 'Restableciendo...',
    createAccount: 'Crear una nueva cuenta',
    fullName: 'Nombre Completo',
    storeNumber: 'Número de Tienda',
    storeNumberPlaceholder: 'ej., 00727',
    creatingAccount: 'Creando cuenta...',
    alreadyHaveAccount: '¿Ya tiene una cuenta? Inicie sesión',
    registrationSuccessful: 'Registro exitoso. Por favor, inicie sesión.',
    registrationFailed: 'Error en el registro'
  },
  navigation: {
    dashboard: 'Panel',
    evaluations: 'Evaluaciones',
    myEvaluations: 'Mis Evaluaciones',
    employees: 'Empleados',
    training: 'Capacitación',
    reports: 'Informes',
    settings: 'Configuración',
    profile: 'Perfil',
    help: 'Ayuda',
    admin: 'Administración',
    leadership: 'Liderazgo',
    kitchen: 'Cocina',
    tasks: 'Tareas',
    me: 'YO',
    teamMembers: 'Miembros del Equipo',
    myProfile: 'Mi Perfil',
    userMenu: 'Menú de Usuario',
    wasteTracker: 'Seguimiento de Residuos',
    analytics: 'Análisis',
    equipmentStatus: 'Estado del Equipo',
    foodSafety: 'Seguridad Alimentaria',
    cleaningSchedule: 'Programa de Limpieza'
  },
  users: {
    title: 'Miembros del Equipo',
    subtitle: 'Gestiona a los miembros de tu equipo y su información',
    searchPlaceholder: 'Buscar por nombre, correo o puesto...'
  },
  dashboard: {
    title: 'Panel',
    welcome: 'Bienvenido',
    welcomeBack: 'Bienvenido de nuevo, {{name}}!',
    viewFullProfile: 'Ver Perfil Completo',
    upcomingEvaluations: 'Próximas Evaluaciones',
    recentActivity: 'Actividad Reciente',
    quickStats: 'Estadísticas Rápidas',
    viewAll: 'Ver Todo',
    evaluationsDue: 'Evaluaciones Pendientes',
    employeesInTraining: 'Empleados en Capacitación',
    completedEvaluations: 'Evaluaciones Completadas',
    pendingReviews: 'Revisiones Pendientes',
    currentPerformance: 'Rendimiento Actual',
    nextEvaluation: 'Próxima Evaluación',
    daysAway: 'en {{days}} días',
    lastEvaluation: 'Última evaluación: {{date}}',
    completeSelfEvaluation: 'Completar Auto-Evaluación',
    pendingManagerReview: 'Pendiente de Revisión del Gerente',
    reviewAndAcknowledge: 'Revisar y Confirmar',
    notScheduled: 'No Programada',
    noUpcomingEvaluation: 'No hay evaluación próxima',
    activeGoals: 'Objetivos Activos',
    goalsInProgress: 'objetivos en progreso',
    currentGoals: 'Objetivos Actuales',
    trackYourProgress: 'Seguimiento de tu progreso',
    noActiveGoals: 'No hay objetivos activos',
    due: 'Vence el {{date}}',
    trainingProgress: 'Progreso de Capacitación',
    yourAssignedTrainingPlans: 'Tus planes de capacitación asignados',
    noActiveTrainingPlans: 'No hay planes de capacitación activos',
    activeTraining: 'Capacitación Activa',
    tasksCompleted: '{{completed}} de {{total}} tareas completadas',
    recentlyCompleted: 'Completados Recientemente',
    completedOn: 'Completado el {{date}}',
    recentAchievements: 'Logros Recientes',
    yourLatestAccomplishments: 'Tus últimos logros',
    noRecentAchievements: 'No hay logros recientes',
    upcomingSchedule: 'Próximos Eventos',
    yourNextEvents: 'Tus próximos eventos',
    noScheduleDataAvailable: 'No hay datos de horario disponibles',
    noUpcomingEvents: 'No hay eventos próximos',
    developmentGoals: 'Objetivos de Desarrollo',
    viewEvaluationHistory: 'Ver historial de evaluaciones',
    viewRequiredTraining: 'Ver capacitación requerida',
    newIncident: 'Nuevo Incidente',
    completedInDays: '{{count}} completados en 30 días',
    openIncidents: 'Incidentes Abiertos',
    resolvedThisMonth: '{{count}} resueltos este mes',
    teamSize: 'Tamaño del Equipo',
    inTraining: '{{count}} en capacitación',
    overallPerformance: 'Rendimiento General',
    fromLastMonth: '+2.5% desde el mes pasado',
    performanceTrends: 'Tendencias de Rendimiento',
    performanceDescription: 'Rendimiento de FOH vs BOH durante las últimas 4 semanas',
    quickActions: 'Acciones Rápidas',
    scheduleEvaluation: 'Programar Evaluación',
    setTeamGoals: 'Establecer Objetivos del Equipo',
    viewTeam: 'Ver Equipo',
    trainingMaterials: 'Materiales de Capacitación',
    next7Days: 'Próximos 7 días',
    last7Days: 'Últimos 7 días',
    noUpcomingEvaluations: 'No hay evaluaciones próximas',
    recentIncidents: 'Incidentes Recientes',
    noActiveIncidents: 'No hay incidentes activos'
  },
  evaluations: {
    title: 'Evaluaciones',
    performanceReviews: 'Revisiones de Rendimiento',
    trackAndManageEvaluations: 'Seguimiento y gestión de evaluaciones de empleados',
    schedule: 'Programar',
    create: 'Crear Evaluación',
    view: 'Ver Evaluación',
    edit: 'Editar Evaluación',
    delete: 'Eliminar Evaluación',
    status: 'Estado',
    employee: 'Empleado',
    evaluator: 'Evaluador',
    date: 'Fecha',
    score: 'Puntuación',
    comments: 'Comentarios',
    submit: 'Enviar Evaluación',
    draft: 'Guardar como Borrador',
    pending: 'Pendiente',
    completed: 'Completada',
    approved: 'Aprobada',
    rejected: 'Rechazada',
    scheduled: 'Programada',
    inProgress: 'En Progreso',
    overdue: 'Atrasada',
    upcoming: 'Próxima',
    noEvaluations: 'No se encontraron evaluaciones',
    confirmDelete: 'Confirmar Eliminación',
    confirmDeleteMessage: '¿Está seguro de que desea eliminar esta evaluación? Esta acción no se puede deshacer.',
    deleteSuccess: 'Evaluación eliminada con éxito',
    saveSuccess: 'Evaluación guardada con éxito',
    submitSuccess: 'Evaluación enviada con éxito',
    reminderSentSuccess: 'Recordatorio de confirmación enviado exitosamente',

    // Status messages
    pendingSelfEvaluation: 'Pendiente de Auto-Evaluación',
    pendingManagerReview: 'Pendiente de Revisión del Gerente',
    inReviewSession: 'En Sesión de Revisión',
    completedAndAcknowledged: 'Completada y Confirmada',
    actionRequiredSelfEvaluation: 'Acción Requerida: Auto-Evaluación',
    actionRequiredScheduleReview: 'Acción Requerida: Programar Revisión',
    actionRequiredCompleteReview: 'Acción Requerida: Completar Revisión',
    actionRequiredAcknowledge: 'Acción Requerida: Confirmar',
    awaitingSelfEvaluation: 'Esperando Auto-Evaluación',
    leaderReviews: 'Revisión de Líderes',

    // Form labels
    scheduledDate: 'Fecha Programada',
    reviewSessionDate: 'Fecha de Sesión de Revisión',
    overallComments: 'Comentarios Generales',
    developmentPlan: 'Plan de Desarrollo',
    selfEvaluation: 'Auto-Evaluación',
    managerEvaluation: 'Evaluación del Gerente',
    acknowledgement: 'Confirmación',
    acknowledged: 'Confirmado',
    notScheduled: 'No Programada',

    // Actions
    startSelfEvaluation: 'Iniciar Auto-Evaluación',
    scheduleReview: 'Programar Revisión',
    completeReview: 'Completar Revisión',
    acknowledgeEvaluation: 'Confirmar Evaluación',
    changeEvaluator: 'Cambiar Evaluador',
    selectEvaluator: 'Seleccionar Evaluador',
    updateEvaluator: 'Actualizar Evaluador',

    // Grading scale
    poor: 'Deficiente',
    fair: 'Regular',
    good: 'Bueno',
    veryGood: 'Muy Bueno',
    excellent: 'Excelente',
    significantImprovementNeeded: 'Se necesita mejora significativa',
    belowExpectations: 'Por debajo de las expectativas',
    meetsExpectations: 'Cumple las expectativas',
    exceedsExpectations: 'Supera las expectativas',
    outstandingPerformance: 'Rendimiento excepcional',

    // Question types
    rating: 'Calificación',
    text: 'Texto',
    multipleChoice: 'Opción Múltiple',
    trueFalse: 'Verdadero/Falso',
    ratingScale: 'Escala de Calificación',

    // Messages
    evaluationUpdated: 'Evaluación actualizada exitosamente',
    evaluatorUpdated: 'Evaluador actualizado exitosamente',
    failedToUpdateEvaluator: 'Error al actualizar el evaluador',
    evaluationNotFound: 'Evaluación no encontrada',
    noPermissionToEdit: 'No tiene permisos para editar esta evaluación',
    pleaseCompleteAllRequired: 'Por favor complete todos los campos requeridos',

    // Templates
    template: 'Plantilla',
    selectTemplate: 'Seleccionar Plantilla',
    noTemplatesAvailable: 'No hay plantillas disponibles',

    // 360 Evaluations
    evaluation360: 'Evaluación 360°',
    addEvaluators: 'Agregar Evaluadores',
    evaluators: 'Evaluadores',
    pendingEvaluators: 'Evaluadores Pendientes',
    selectEvaluators: 'Seleccionar Evaluadores',
    relationship: 'Relación',
    peer: 'Compañero',
    directReport: 'Subordinado Directo',
    self: 'Auto-evaluación',

    // Assessment types
    selfAssessment: 'Auto-evaluación',
    feedback360: 'Retroalimentación 360°',
    skillAssessment: 'Evaluación de Habilidades',
    characterAssessment: 'Evaluación de Carácter',
    teamAssessment: 'Evaluación de Equipo',

    // UI Labels
    myTeam: 'Mi Equipo',
    templates: 'Plantillas',
    newReview: 'Nueva Revisión',
    pendingReviews: 'Revisiones Pendientes',
    inReview: 'En Revisión',
    unacknowledged: 'Sin Confirmar',
    searchEvaluations: 'Buscar evaluaciones...',
    allReviews: 'Todas las Revisiones',
    yourTeam: 'Tu Equipo',
    allStore: 'Toda la Tienda',
    noPendingEvaluations: 'No se encontraron evaluaciones pendientes',
    noCompletedEvaluations: 'No se encontraron evaluaciones completadas',

    // Card labels
    due: 'Vencimiento:',
    evaluatorLabel: 'Evaluador:',

    // Position translations
    director: 'Director',
    manager: 'Gerente',
    leader: 'Líder',
    teamMember: 'Miembro del Equipo',

    // Template names (common ones)
    teamMemberHeartsAndHandsEvaluation: 'Evaluación Corazones y Manos del Miembro del Equipo',

    // Error messages
    failedToDelete: 'Error al eliminar la evaluación',
    failedToSendNotification: 'Error al enviar la notificación',
    errorLoadingEvaluations: 'Error al Cargar las Evaluaciones',
    errorLoadingMessage: 'Hubo un problema al cargar las evaluaciones. Por favor, inténtelo de nuevo más tarde.'
  },
  employees: {
    title: 'Empleados',
    add: 'Agregar Empleado',
    edit: 'Editar Empleado',
    view: 'Ver Empleado',
    delete: 'Eliminar Empleado',
    name: 'Nombre',
    email: 'Correo Electrónico',
    phone: 'Teléfono',
    position: 'Posición',
    department: 'Departamento',
    hireDate: 'Fecha de Contratación',
    status: 'Estado',
    active: 'Activo',
    inactive: 'Inactivo',
    evaluations: 'Evaluaciones',
    training: 'Capacitación',
    noEmployees: 'No se encontraron empleados',
    confirmDelete: '¿Está seguro de que desea eliminar este empleado?',
    deleteSuccess: 'Empleado eliminado con éxito',
    saveSuccess: 'Empleado guardado con éxito'
  },
  training: {
    title: 'Capacitación',
    dashboard: 'Panel de Capacitación',
    plans: 'Planes de Capacitación',
    progress: 'Progreso de Capacitación',
    newHires: 'Nuevos Empleados',
    completionRate: 'Tasa de Finalización',
    trainingPlans: 'Planes de Capacitación',
    employeesNeedTraining: 'Empleados Necesitan Capacitación',
    viewEmployees: 'Ver Empleados',
    failedToLoadStats: 'Error al cargar las estadísticas del panel',
    createPlan: 'Crear Plan de Capacitación',
    editPlan: 'Editar Plan de Capacitación',
    deletePlan: 'Eliminar Plan de Capacitación',
    planName: 'Nombre del Plan',
    planDescription: 'Descripción del Plan',
    planType: 'Tipo de Plan',
    modules: 'Módulos',
    addModule: 'Añadir Módulo',
    moduleTitle: 'Título del Módulo',
    moduleDescription: 'Descripción del Módulo',
    moduleContent: 'Contenido del Módulo',
    savePlan: 'Guardar Plan',
    cancel: 'Cancelar',
    confirmDelete: '¿Está seguro de que desea eliminar este plan de capacitación?',
    planDeleted: 'Plan de capacitación eliminado con éxito',
    planSaved: 'Plan de capacitación guardado con éxito',
    assignTraining: 'Asignar Capacitación',
    selectEmployees: 'Seleccionar Empleados',
    selectTrainingPlan: 'Seleccionar Plan de Capacitación',
    assign: 'Asignar',
    trainingAssigned: 'Capacitación asignada con éxito'
  },
  settings: {
    title: 'Configuración',
    subtitle: 'Administrar la configuración de su tienda',
    general: 'Configuración General',
    appearance: 'Apariencia',
    language: 'Idioma',
    english: 'Inglés',
    spanish: 'Español',
    darkMode: 'Modo Oscuro',
    compactMode: 'Modo Compacto',
    // Sección de cocina
    kitchenChecklistOptions: 'Opciones de Lista de Verificación',
    kitchenChecklistOptionsDescription: 'Elija qué listas de verificación por turno ejecuta su cocina cada día',
    kitchenShiftTimes: 'Horarios de Turnos',
    kitchenShiftTimesDescription: 'Defina cuándo comienza y termina cada turno para que las listas se abran a la hora correcta',
    // Sección de información de la tienda
    storeInfo: 'Información de la Tienda',
    storeInformation: 'Información de la Tienda',
    storeInformationDescription: 'Administre los datos de contacto de la tienda usados en toda la aplicación',
    storeName: 'Nombre de la Tienda',
    storeNumber: 'Número de la Tienda',
    storeAddress: 'Dirección de la Tienda',
    storePhone: 'Número de Teléfono',
    storeEmail: 'Dirección de Correo Electrónico',
    visionStatement: 'Declaración de Visión',
    missionStatement: 'Declaración de Misión',
    saveChanges: 'Guardar Cambios',
    resetToDefault: 'Restablecer a Valores Predeterminados',
    gradingScales: 'Escalas de Calificación',
    confirmReset: '¿Está seguro de que desea restablecer toda la configuración a los valores predeterminados?',
    settingsSaved: 'Configuración guardada con éxito',
    resetSuccess: 'Configuración restablecida a valores predeterminados',

    // User Access Settings
    userAccess: 'Acceso de Usuario',
    roleManagement: 'Gestión de Roles',
    storeDirectorAccess: 'Acceso de Director de Tienda',
    kitchenDirectorAccess: 'Acceso de Director de Cocina',
    serviceDirectorAccess: 'Acceso de Director de Servicio',
    storeLeaderAccess: 'Acceso de Líder de Tienda',
    trainingLeaderAccess: 'Acceso de Líder de Capacitación',
    shiftLeaderAccess: 'Acceso de Líder de Turno',
    fohLeaderAccess: 'Acceso de Líder de FOH',
    bohLeaderAccess: 'Acceso de Líder de BOH',
    dtLeaderAccess: 'Acceso de Líder de DT',
    roleManagementDescription: 'Elija lo que cada rol de liderazgo puede ver y hacer',
    storeDirectorAccessDescription: 'Acceso completo a todas las áreas de la tienda',
    kitchenDirectorAccessDescription: 'Acceso completo a las operaciones de cocina y al equipo de BOH',
    serviceDirectorAccessDescription: 'Acceso completo a las operaciones de mostrador y al equipo de FOH',
    storeLeaderAccessDescription: 'Administrar las operaciones diarias en ambos departamentos',
    trainingLeaderAccessDescription: 'Administrar planes de capacitación, certificaciones y el progreso de nuevos empleados',
    shiftLeaderAccessDescription: 'Dirigir el turno y administrar a los miembros del equipo en servicio',
    fohLeaderAccessDescription: 'Dirigir el mostrador y el comedor durante un turno',
    bohLeaderAccessDescription: 'Dirigir la cocina y la preparación de alimentos durante un turno',
    dtLeaderAccessDescription: 'Dirigir el autoservicio durante un turno',

    // Contraseña y seguridad de la cuenta
    passwordRequirements: 'Defina las reglas que los miembros del equipo deben seguir al crear una contraseña',
    minLength: 'Longitud mínima',
    characters: 'caracteres',
    requireNumbers: 'Requerir Números',
    requireNumbersDescription: 'Las contraseñas deben contener al menos un número',
    requireSpecialChars: 'Requerir Caracteres Especiales',
    requireSpecialCharsDescription: 'Las contraseñas deben contener al menos un símbolo, como ! o #',
    security: 'Seguridad de la Cuenta',
    securityDescription: 'Controle cuánto tiempo permanecen conectados los usuarios y cómo se manejan los inicios de sesión fallidos',
    sessionTimeout: 'Tiempo de Espera de Sesión',
    sessionTimeoutDescription: 'Cerrar la sesión automáticamente después de este tiempo de inactividad',
    selectTimeout: 'Seleccione un tiempo de espera',
    minutes: 'minutos',
    hour: 'hora',
    hours: 'horas',
    maxLoginAttempts: 'Intentos Máximos de Inicio de Sesión',
    maxLoginAttemptsDescription: 'Bloquear la cuenta después de esta cantidad de intentos fallidos',
    selectAttempts: 'Seleccione los intentos',
    attempts: 'intentos',

    // Evaluation Settings
    evaluation: 'Configuración de Evaluación',
    evaluationDescription: 'Controle cómo se revisan y aprueban las evaluaciones',
    workflowTypeDescription: 'Cuántos pasos de aprobación atraviesa una evaluación antes de ser final',
    selectWorkflow: 'Seleccione un flujo de trabajo',
    trainingAccessDescription: 'Quién puede crear y asignar planes de capacitación',
    certificationApprovalDescription: 'Quién puede aprobar cuando un miembro del equipo completa una certificación',
    metricsAccessDescription: 'Quién puede ver las métricas e informes de rendimiento de la tienda',
    errorSavingSettings: 'No se pudo guardar su configuración. Inténtelo de nuevo.',
    updateError: 'Algo salió mal al actualizar. Inténtelo de nuevo.',
    departmentRestriction: 'Restricción de Departamento',
    requireStoreLeaderReview: 'Requerir Revisión del Líder de Tienda',
    requireDirectorApproval: 'Requerir Aprobación del Director',
    trainingAccess: 'Acceso a Capacitación',
    certificationApproval: 'Aprobación de Certificación',
    metricsAccess: 'Acceso a Métricas',
    workflowType: 'Tipo de Flujo de Trabajo',
    workflowSimple: 'Simple',
    workflowStandard: 'Estándar',
    workflowStrict: 'Estricto',

    // Evaluation Scheduling
    scheduling: 'Programación',
    autoSchedule: 'Programar Evaluaciones Automáticamente',
    frequency: 'Frecuencia de Evaluación (Días)',
    cycleStart: 'Inicio del Ciclo de Evaluación',
    hireDate: 'Fecha de Contratación',
    calendarYear: 'Año Calendario',
    fiscalYear: 'Año Fiscal',
    custom: 'Fecha Personalizada',
    customStartDate: 'Fecha de Inicio Personalizada',
    transitionMode: 'Modo de Transición',
    immediate: 'Inmediato',
    completeCycle: 'Ciclo Completo',
    alignNext: 'Alinear Siguiente',

    // Access Control Settings
    setupViewAccess: 'Acceso a Vista de Configuración',
    setupViewAccessDescription: 'Controlar quién puede acceder a la función de Vista de Configuración',
    evaluationAccessControls: 'Controles de Acceso a Evaluaciones',
    evaluationAccessControlsDescription: 'Administrar permisos de evaluación para diferentes roles',

    // Settings descriptions
    darkModeDescription: 'Habilitar modo oscuro para la aplicación',
    compactModeDescription: 'Usar diseño compacto para mostrar más contenido',
    languageDescription: 'Seleccione su idioma preferido',
    departmentRestrictionDescription: 'Restringir a los evaluadores a evaluar solo a los miembros del equipo en su departamento',
    storeLeaderReviewDescription: 'Requerir revisión del líder de tienda antes de finalizar las evaluaciones',
    directorApprovalDescription: 'Requerir aprobación del director para las evaluaciones completadas',
    autoScheduleDescription: 'Programar automáticamente las evaluaciones según la frecuencia',

    // Validation and errors
    validationError: 'Por favor, corrija los errores de validación antes de guardar',
    storeNumberRequired: 'El número de tienda es obligatorio',
    storeNameRequired: 'El nombre de la tienda es obligatorio',
    invalidEmail: 'Por favor, introduzca una dirección de correo electrónico válida',
    invalidPhone: 'Por favor, introduzca un número de teléfono válido',

    // Why We Exist Form
    whyWeExist: 'Por Qué Existimos',
    purpose: 'Propósito',
    purposePlaceholder: 'Ingrese el propósito central de su tienda...',
    purposeExample: 'Ejemplo: "Cambiar árboles genealógicos"',
    mission: 'Misión',
    missionPlaceholder: 'Ingrese la declaración de misión de su tienda...',
    missionExample: 'Ejemplo: "Fomentar un ambiente de hospitalidad que enfatice la ejecución impecable y promueva una cultura de aprendizaje continuo"',
    values: 'Valores',
    valuesPlaceholder: 'Ingrese un valor fundamental...',
    valuesExamples: 'Ejemplos: "Totalmente comprometidos con nuestra gente", "Obsesionados con nuestros huéspedes", "Ejecución impecable", "Crear una atmósfera hospitalaria"',
    strategy: 'Estrategia',
    strategyPlaceholder: 'Ingrese el enfoque estratégico de su tienda...',
    strategyExample: 'Ejemplo: "Capturar participación de mercado mediante la combinación de ejecución impecable con un compromiso firme de involucrar a nuestros huéspedes en sus vidas"',
    saving: 'Guardando...',
    saveWhyStatement: 'Guardar Declaración de Propósito',
  },
  errors: {
    notFound: 'Página no encontrada',
    unauthorized: 'No está autorizado para acceder a esta página',
    serverError: 'Se produjo un error en el servidor',
    networkError: 'Se produjo un error de red',
    tryAgain: 'Por favor, inténtelo de nuevo',
    contactSupport: 'Si el problema persiste, póngase en contacto con soporte'
  },
  notifications: {
    failedToLoad: 'Error al cargar las notificaciones',
    failedToProcess: 'Error al procesar la notificación',
    failedToDelete: 'Error al eliminar la notificación. Por favor, inténtelo de nuevo.',
    markAllAsRead: 'Marcar todas como leídas',
    viewAll: 'Ver todas las notificaciones',
    invalidNotification: 'Notificación no válida: No se encontró ID de notificación',
    dismissSuccess: 'Notificación descartada con éxito',
    notFound: 'Notificación no encontrada o ya descartada',
    noPermission: 'No tiene permiso para descartar esta notificación'
  },
  kitchen: {
    title: 'Gestión de Cocina',
    subtitle: 'Administrar y seguir las operaciones de cocina',
    dashboard: 'Panel',
    shiftChecklists: 'Listas de Verificación de Turno',
    wasteTracker: 'Seguimiento de Desperdicios',
    analytics: 'Análisis',
    equipmentStatus: 'Estado del Equipo',
    foodSafety: 'Seguridad Alimentaria',
    cleaningSchedule: 'Programa de Limpieza',
    backHome: 'Volver al Inicio',

    // Kitchen Home
    kitchenDashboard: 'Panel de Cocina',
    kitchenOverview: 'Resumen de Cocina',
    attentionNeeded: 'Requiere Atención',
    taskCompletion: 'Finalización de Tareas',
    lastUpdate: 'Última Actualización',
    pendingChecklists: 'Listas Pendientes',
    temperatureChecks: 'Controles de Temperatura',
    criticalTasks: 'tareas críticas necesitan atención',
    todaysWaste: 'Desperdicios de Hoy',
    itemsTracked: 'Elementos Rastreados',
    needsMaintenance: 'Necesita Mantenimiento',
    temperatureAlerts: 'Alertas de Temperatura',
    equipmentOffline: 'unidades de equipo fuera de línea',
    completionRate: 'Tasa de Finalización',
    overdueTasks: 'Tareas Atrasadas',
    criticalCleaningTasks: 'tareas críticas de limpieza',

    // Quick Actions
    startFoodSafetyChecklist: 'Iniciar Lista de Seguridad Alimentaria',
    logWasteEntry: 'Registrar Desperdicio',
    checkEquipmentTemperatures: 'Verificar Temperaturas del Equipo',
    completeCleaningTask: 'Completar Tarea de Limpieza',
    completeShiftChecklist: 'Completar Lista de Turno',

    // Waste Tracker
    addWasteEntry: 'Añadir Entrada de Desperdicio',
    viewAnalytics: 'Ver Análisis',
    waste: 'Desperdicio',
    donations: 'Donaciones',
    todaysDonations: 'Donaciones de Hoy',
    topDonation: 'Donación Principal',
    mostWasted: 'Más Desperdiciado',
    noItemsYet: 'Aún no hay artículos',
    lastAt: 'Último',
    startTracking: 'Comenzar seguimiento',
    items: 'Artículos',
    prices: 'Precios',
    bulkEntry: 'Entrada Masiva',
    breakfast: 'Desayuno',
    lunch: 'Almuerzo',
    dinner: 'Cena',
    wasteReason: 'Razón del Desperdicio',
    overproduction: 'Sobreproducción',
    qualityIssues: 'Problemas de Calidad',
    expired: 'Caducado',
    droppedContaminated: 'Caído/Contaminado',
    dropped: 'Caído',
    todaysEntries: 'Entradas de Hoy',
    entries: 'Entradas',
    today: 'Hoy',
    singleDay: 'Día Individual',
    dateRange: 'Rango de Fechas',
    notes: 'Notas',
    noDonationsLoggedToday: 'No se registraron donaciones hoy',
    noDonationsLogged: 'No se registraron donaciones',
    noWasteLoggedToday: 'No se registró desperdicio hoy',
    noWasteLogged: 'No se registró desperdicio',
    tapItemsAbove: 'Toque los artículos arriba para comenzar el seguimiento',
    itemsLogged: 'artículos registrados',
    processing: 'Procesando...',
    added: '¡Agregado!',
    customItems: 'Artículos Personalizados',
    customItemsDescription: 'Agregar, editar o eliminar artículos de desperdicio personalizados.',
    managePrices: 'Administrar Precios',
    managePricesDescription: 'Personalizar precios de artículos para su tienda.',
    printReport: 'Imprimir Informe',
    generatedBy: 'Generado por Sistema de Gestión de Cocina CFA',
    lbs: 'lbs',
    oz: 'oz',
    customEntry: 'Entrada Personalizada',
    itemName: 'Nombre del artículo',
    weightLbs: 'Peso (lbs)',
    qty: 'Cant.',
    price: 'Precio ($)',
    addEntry: 'Agregar Entrada',
    deleteEntry: '¿Eliminar Entrada?',
    deleteEntryDescription: 'Esta acción no se puede deshacer.',
    addDonation: 'Agregar Donación',
    enterDetailsFor: 'Ingrese detalles para',
    beingDonated: 'siendo donado',
    byWeight: 'Por Peso',
    byQuantity: 'Por Cantidad',
    weight: 'Peso',
    enterWeight: 'Ingrese peso',
    quantityItems: 'Cantidad (artículos)',
    enterNumberOfItems: 'Ingrese número de artículos',

    // Equipment
    addEquipment: 'Añadir Equipo',
    reportIssue: 'Reportar Problema',

    // Food Safety
    completeChecklist: 'Completar Lista',
    addChecklist: 'Añadir Lista',

    // Cleaning
    markComplete: 'Marcar como Completado',
    addTask: 'Añadir Tarea',
  },
  roadmaps: {
    // General
    title: 'Hojas de Ruta',
    subtitle: 'Gestionar hojas de ruta de liderazgo y desarrollo',
    roadmap: 'Hoja de Ruta',
    roadmaps: 'Hojas de Ruta',
    areaRoadmap: 'Hoja de Ruta de Área',
    areaRoadmaps: 'Hojas de Ruta de Área',
    leadershipRoadmap: 'Hoja de Ruta de Liderazgo',

    // Status
    active: 'Activo',
    completed: 'Completado',
    archived: 'Archivado',
    draft: 'Borrador',
    inProgress: 'En Progreso',

    // Actions
    create: 'Crear',
    edit: 'Editar',
    view: 'Ver',
    delete: 'Eliminar',
    archive: 'Archivar',
    complete: 'Completar',
    save: 'Guardar',
    cancel: 'Cancelar',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',

    // Metrics
    metrics: 'Métricas',
    metric: 'Métrica',
    currentValue: 'Valor Actual',
    target: 'Objetivo',
    performance: 'Rendimiento',
    trend: 'Tendencia',
    history: 'Historial',
    lastUpdated: 'Última Actualización',
    updateMetric: 'Actualizar Métrica',
    addMetric: 'Añadir Métrica',

    // Chart and Trend
    preview: 'Vista Previa',
    startTracking: 'Comenzar Seguimiento',
    noChange: 'Sin Cambios',
    points: 'puntos',
    actual: 'Real',
    noData: 'Sin Datos',

    // Focus Areas
    focusAreas: 'Áreas de Enfoque',
    focusArea: 'Área de Enfoque',
    addFocusArea: 'Añadir Área de Enfoque',
    editFocusArea: 'Editar Área de Enfoque',

    // Tasks
    tasks: 'Tareas',
    task: 'Tarea',
    addTask: 'Añadir Tarea',
    editTask: 'Editar Tarea',
    completeTask: 'Completar Tarea',
    taskCompleted: 'Tarea Completada',
    pendingTasks: 'Tareas Pendientes',
    completedTasks: 'Tareas Completadas',

    // Team Members
    teamMembers: 'Miembros del Equipo',
    teamMember: 'Miembro del Equipo',
    addTeamMember: 'Añadir Miembro del Equipo',
    removeTeamMember: 'Remover Miembro del Equipo',

    // Meetings
    meetings: 'Reuniones',
    meeting: 'Reunión',
    scheduleMeeting: 'Programar Reunión',
    meetingNotes: 'Notas de Reunión',
    nextMeeting: 'Próxima Reunión',

    // Templates
    templates: 'Plantillas',
    template: 'Plantilla',
    useTemplate: 'Usar Plantilla',
    selectTemplate: 'Seleccionar Plantilla',

    // Dialogs and Confirmations
    deleteConfirmation: 'Confirmación de Eliminación',
    archiveConfirmation: 'Confirmación de Archivo',
    completeConfirmation: 'Confirmación de Finalización',
    deleteWarning: '¿Está seguro de que desea eliminar esta hoja de ruta?',
    archiveWarning: '¿Está seguro de que desea archivar esta hoja de ruta?',
    completeWarning: '¿Está seguro de que desea marcar esta hoja de ruta como completada?',
    typeDeleteToConfirm: 'Escriba ELIMINAR para confirmar:',
    typeDelete: 'ELIMINAR',

    // Success Messages
    createdSuccess: 'Hoja de ruta creada exitosamente',
    updatedSuccess: 'Hoja de ruta actualizada exitosamente',
    deletedSuccess: 'Hoja de ruta eliminada exitosamente',
    archivedSuccess: 'Hoja de ruta archivada exitosamente',
    completedSuccess: 'Hoja de ruta completada exitosamente',
    metricUpdatedSuccess: 'Métrica actualizada exitosamente',

    // Error Messages
    loadError: 'Error al cargar la hoja de ruta',
    saveError: 'Error al guardar la hoja de ruta',
    deleteError: 'Error al eliminar la hoja de ruta',
    notFound: 'Hoja de ruta no encontrada',

    // Loading States
    loading: 'Cargando...',
    saving: 'Guardando...',
    deleting: 'Eliminando...',
    archiving: 'Archivando...',
    completing: 'Completando...',

    // Filters and Search
    filterBy: 'Filtrar por',
    searchRoadmaps: 'Buscar hojas de ruta',
    showAll: 'Mostrar Todas',
    showActive: 'Mostrar Activas',
    showCompleted: 'Mostrar Completadas',
    showArchived: 'Mostrar Archivadas',

    // Progress and Statistics
    progress: 'Progreso',
    completion: 'Finalización',
    completionRate: 'Tasa de Finalización',
    overallProgress: 'Progreso General',

    // Areas and Departments
    kitchen: 'Cocina',
    driveThru: 'Auto Servicio',
    frontCounter: 'Mostrador Frontal',
    foodSafety: 'Seguridad Alimentaria',
    quality: 'Calidad',
    talent: 'Talento',

    // Specific Metrics
    orderAccuracy: 'Precisión de Pedidos',
    attentiveCourteous: 'Atento y Cortés',
    cleanliness: 'Limpieza',
    guestSatisfaction: 'Satisfacción del Cliente',
    evaluationCompletion: 'Finalización de Evaluaciones',

    // Time and Frequency
    daily: 'Diario',
    weekly: 'Semanal',
    monthly: 'Mensual',
    quarterly: 'Trimestral',
    annually: 'Anual',

    // Positions and Roles
    director: 'Director',
    coordinator: 'Coordinador',
    leader: 'Líder',
    partner: 'Socio',
    teamMemberRole: 'Miembro del Equipo'
  }
};